import { render, staticRenderFns } from "./ProductsDropdown.vue?vue&type=template&id=2a40c478&scoped=true&"
import script from "./ProductsDropdown.vue?vue&type=script&lang=js&"
export * from "./ProductsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDropdown.vue?vue&type=style&index=0&id=2a40c478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a40c478",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
